import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { PlanIntervalType } from '@fitness-force/enum';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'balance-age-bucket',
  templateUrl: './balance-age-bucket.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class BalanceAgeBucketComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);
  private translate = inject(TranslateService);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  ngOnInit() {}

  getData(data: string) {
    const regex = /\d+/;
    let response: string = '';
    const match = data.match(regex);
    if (match) {
      this.translate
        .get('REPORTS.REPORT_TEMPLATE.COLUMNS.ai_above', {
          days: parseInt(match[0], 10),
        })
        .subscribe((trans) => {
          response = trans;
        });
    }
    return response;
  }
}
